import ChainSolarSystemIllustration from "./ChainSolarSystemIllustration"

export const AppsNavVisual = () => {
  return (
    <div className="w-full h-full flex items-end justify-center px-4 pb-0 pt-12">
      {/* App Window Container */}
      <div className="w-full h-24 border border-neutral-500/20 rounded-t-lg border-b-0 flex flex-col p-3 gap-3 bg-transparent shadow-xs">
        {/* Header: Avatar + Title */}
        <div className="flex items-center gap-2 shrink-0">
          <div className="w-3 h-3 rounded-full bg-neutral-500/20" />
          <div className="h-1.5 w-12 rounded-full bg-neutral-500/10" />
        </div>

        {/* Main Body Content */}
        <div className="flex-1 flex gap-4 overflow-hidden">
          {/* Left Column: Stats/List */}
          <div className="w-[35%] flex flex-col gap-1.5 pt-1">
            {/* Title/Subtitle pills */}
            <div className="flex flex-col gap-1">
              <div className="h-1 w-6 rounded-full bg-neutral-500/10 mb-0.5 shrink-0" />
              <div className="h-1.5 w-10 rounded-full bg-neutral-500/10 mb-1 shrink-0" />
            </div>

            {/* 4 Rows of 2 columns grid */}
            <div className="grid grid-cols-2 gap-x-2 gap-y-1.5">
              {[0, 1, 2, 3].map((i) => (
                <>
                  <div key={`l-${i}`} className="h-1 w-full rounded-full bg-neutral-500/10" />
                  <div key={`r-${i}`} className="h-1 w-full rounded-full bg-neutral-500/10" />
                </>
              ))}
            </div>
          </div>

          {/* Right Column: Chart */}
          <div className="flex-1 border border-neutral-500/20 rounded-sm relative flex items-center justify-center">
            {/* Simple Chart Line */}
            <svg
              className="w-full h-full absolute inset-0 text-neutral-500/30 p-2"
              preserveAspectRatio="none"
              viewBox="0 0 100 50"
            >
              <path
                d="M0 45 L 20 30 L 40 35 L 60 20 L 80 25 L 100 10"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                vectorEffect="non-scaling-stroke"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ChainsNavVisual = () => {
  return (
    <div className="w-full h-full flex items-end justify-center pb-4 pr-4">
      <ChainSolarSystemIllustration className="text-neutral-500 absolute -bottom-6 -right" />
    </div>
  )
}
